import React from 'react';
import PropTypes from 'prop-types';
import BaseProductPartsListContainer from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import { useDispatch, useSelector } from 'react-redux';
import ProductPartsList from '@configuratorware/configurator-frontendgui/App/Modules/Creator/Containers/ProductPartsList';
import memoize from '@configuratorware/configurator-frontendgui/Utils/Function/memoize';
import ProductPart from '../../Components/ProductPart/ProductPart';
import { setSelectedProductPart } from '../../Reducers/Menu/Actions';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import _ from 'lodash';

const CustomProductsPartContainer = (props) => {
  const { filteredOptionclassifications } = useSelector((state) => state.configurator);
  const removeHiddenComponents = memoize((components) =>
    components.filter(({ hiddenInFrontend }) => !hiddenInFrontend)
  );
  const optionclassifications = removeHiddenComponents(filteredOptionclassifications);
  const dispatch = useDispatch();
  // mapping with optionclassification and filtering out hidden optionclassification
  const components = optionclassifications.filter(
    (oc) => !oc.attributes || (oc.attributes && oc.attributes.length === 0)
  );
  const groupedComponents = _(optionclassifications)
    .filter((oc) => oc.attributes && oc.attributes.length > 0)
    .groupBy((a) => {
      const positionAttribute = a.attributes && a.attributes.find((attr) => attr.identifier === 'position');
      return positionAttribute && positionAttribute.values[0].translated_value;
    })
    .map((value, key, i) => {
      return value.length === 1
        ? value[0]
        : {
            title: key,
            key: i,
            identifier: value.map((val) => val.identifier),
            thumbnail: value[0].thumbnail,
            type: value.length > 1 ? 'group' : 'component',
            sequenceNumber: get(value[0], 'sequenceNumber', 0),
            components: value,
          };
    })
    .value();
  return (
    <BaseProductPartsListContainer
      {...props}
      Component={ProductPartsList}
      ProductPartComponent={ProductPart}
      optionclassifications={orderBy(
        components.concat(groupedComponents.map((c, i) => ({ ...c, key: i }))),
        'sequenceNumber'
      )}
      onSelect={(optionclassification) => {
        let component = optionclassification;
        dispatch(setSelectedProductPart(component));
        if (optionclassification.type === 'group') {
          component = optionclassifications.find(
            (oc) => oc.identifier === optionclassification.components[0].identifier
          );
        }
        props.onSelect(component);
      }}
    />
  );
};

CustomProductsPartContainer.propTypes = {
  onSelect: PropTypes.func,
};

export default CustomProductsPartContainer;
